module.exports = __webpack_public_path__ + "img/ico-reply-no.e45fec64.svg";